import { Longhand } from "../longhand.js";
import Base, { compute } from "./border-top-width.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-inline-start-width}
 * @internal
 */
export default Longhand.extend(Base, {
    compute: (borderWidth, style) => {
        const borderStyle = style.computed("border-inline-start-style");
        return compute(borderStyle, borderWidth, style);
    },
});
//# sourceMappingURL=border-inline-start-width.js.map